function readLocationHref(): string | null {
	if (typeof window === "undefined") {
		return null;
	}

	try {
		return window.location.href;
	} catch {
		return null;
	}
}

function readDocumentReferrer(): string | null {
	if (typeof document === "undefined") {
		return null;
	}

	return document.referrer || null;
}

function readQueryParamFromUrl(href: string | null, name: string): string | null {
	if (!href) {
		return null;
	}

	try {
		return new URL(href).searchParams.get(name);
	} catch {
		return null;
	}
}

/**
 * Returns the value of a query parameter from the current URL or the document referrer.
 * If the parameter is not found in the current URL, it will check the referrer URL.
 *
 * @param name - The name of the query parameter to retrieve.
 * @returns The value of the query parameter, or null if not found.
 */
export function getQueryParam(name: string): string | null {
	const value = readQueryParamFromUrl(readLocationHref(), name);
	if (value) {
		return value;
	}

	const referrerValue = readQueryParamFromUrl(readDocumentReferrer(), name);
	if (referrerValue) {
		return referrerValue;
	}

	return null;
}
